import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModuleFE_Advisor_Value } from '@app/advisor-frontend';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { LL_H_C, Show, stopPropagation } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { resolveValueDisplay } from '@app/hcs-shared';
export const AdvisorWizardTree_ValueRenderer = (props) => {
    const value = ModuleFE_Advisor_Value.cache.unique(props.item.id);
    if (!value)
        throw new MUSTNeverHappenException(`Could not find value for id ${props.item.id}`);
    return _jsx(LL_H_C, { className: 'value-node', children: _jsxs(Show, { children: [_jsx(Show.If, { condition: !props.item.disabled, children: _jsx(ICONS.x.component, { onClick: e => {
                            stopPropagation(e);
                            props.item.editable.delete();
                        } }) }), _jsx(Show.If, { condition: true, children: resolveValueDisplay(value) })] }) });
};
//# sourceMappingURL=value-renderer.js.map